import React from 'react';
import Link from '@mui/material/Link';

const SliderTags = props => {
  const { tags } = props;

  return (
    <>
      {tags &&
        tags.map(tag => {
          return (
            <Link color="textPrimary" href={`/topics/${tag}`} key={tag}>
              <span className="badge badge-secondary m-1 mb-2 p-1 pl-2 pr-2 rounded">
                {tag ? tag.toUpperCase() : 'TRAVELFEED'}
              </span>
            </Link>
          );
        })}
      <style jsx global>{`
        @media (min-width: 768px) {
          .tags {
            text-align: right;
          }
        }
      `}</style>
    </>
  );
};

export default SliderTags;
